/**
 * Which surface this page is (parity §0 "Two route tables"): the admin
 * console on the admin hosts, the customer product everywhere else. Decided
 * once, from the hostname, before the router starts — the two surfaces share
 * no routes, and the API tells them apart by the `X-Lemon-Admin-Request`
 * header that every admin-host request carries (src/api/client.ts).
 */

export const ADMIN_HOSTNAMES: ReadonlySet<string> = new Set([
  'admin.lemon-ai.com',
  'admin.local-lemon-ai.com',
  'admin.localhost',
]);

/** Hostnames compare case-insensitively; a trailing root dot is the same host. */
export const isAdminHostname = (hostname: string): boolean =>
  ADMIN_HOSTNAMES.has(hostname.toLowerCase().replace(/\.$/, ''));

export const isAdminSurface = (): boolean =>
  typeof window !== 'undefined' && isAdminHostname(window.location.hostname);

/** Sent on every request from an admin host; the API rejects admin mutations without it. */
export const ADMIN_REQUEST_HEADER = 'X-Lemon-Admin-Request';
